
import { PRIMENG_COLORS } from '@core/classes/global-enums';
import { updatePrimaryPalette } from '@primeuix/themes';


export function changePrimeNgPrimaryColor(color: PRIMENG_COLORS) {
  updatePrimaryPalette({
    50: `{${color}.50}`,
    100: `{${color}.100}`,
    200: `{${color}.200}`,
    300: `{${color}.300}`,
    400: `{${color}.400}`,
    500: `{${color}.500}`,
    600: `{${color}.600}`,
    700: `{${color}.700}`,
    800: `{${color}.800}`,
    900: `{${color}.900}`,
    950: `{${color}.950}`
  });
}

export function setAngelPalleteColors() {
  // ref: https://primeng.org/theming/styled
  updatePrimaryPalette({
    50: '#f0f8fd',
    100: '#d9eef9',
    200: '#b8def3',
    300: '#8ec9ea',
    400: '#5daee0',
    500: '#0b7fbf',
    600: '#096aa0',
    700: '#085786',
    800: '#07486e',
    900: '#063b5b',
    950: '#04273f'
  });
}




